<template>
	<div class="block">
    <el-form :inline="true">
      <el-form-item>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total">
        </el-pagination>
      </el-form-item>
      <el-form-item>
        <button class="btn-go" @click="goPage">GO</button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('clickPage',val)
    },
    goPage() {

    },
  }
};
</script>
<style>
.block {
  margin-top: 20px;
  text-align: center;
}
.btn-go {
  width: 48px;
  height: 28px;
  background-color: #3dd278;
  color: #fff;
  line-height: 28px;
  text-align: center;
  vertical-align: top;
  border: none;
}
.el-pager li.active {
  color: #fff;
  cursor: default;
  background-color: #3dd278;
}
.el-pager li {
  color: #7d8893;
}
</style>


// WEBPACK FOOTER //
// src/components/PageIndex.vue